import { X } from "lucide-react";
import { Language } from "../../../utils/dictionary";
import { dictionary } from "../../../utils/dictionary";
interface ModalDropiIntegrationProps {
    setModalOpenDropi: (open: boolean) => void;
    handlePostDropiIntegration: (token: string) => void;
    token: string;
    setToken: (token: string) => void;
    language: Language;
}

const ModalDropiIntegration = ({ setModalOpenDropi, handlePostDropiIntegration, token, setToken, language }: ModalDropiIntegrationProps) => {
    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md relative">
                <button className="absolute top-4 right-4" onClick={() => setModalOpenDropi(false)}>
                    <X />
                </button>
                <h2 className="text-2xl font-bold mb-4 text-center">{dictionary["add-integration-token"][language]}</h2>
                <label htmlFor="dropiToken" className="block text-sm font-medium text-gray-700 mb-2">
                    {dictionary["dropi-token"][language]}
                </label>
                <input
                    type="text"
                    id="dropiToken"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder={dictionary["example-dropi-token"][language]}
                    onChange={(e) => setToken(e.target.value)}
                />

                <div className="mt-6 flex justify-end space-x-3">
                    <button
                        className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400"
                        onClick={() => setModalOpenDropi(false)}
                    >
                        {dictionary["cancel"][language]}
                    </button>
                    <button
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                        onClick={() => handlePostDropiIntegration(token)}
                    >
                        {dictionary["save"][language]}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalDropiIntegration;